import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-pre',
  templateUrl: './layout-pre.component.html',
  styleUrls: ['./layout-pre.component.scss']
})
export class LayoutPreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
